<template>
	<div>
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="small"
            @close="close"
            v-if="isShowCheckLogin">
            <template slot="header">
				{{ $t('Active Login') }}
            </template>
            <template slot="body">
                <p class="mb-2">{{ $t('This account already logged in on another device, Press OK to continue, this action will force logout another active login') }}</p>
                <!-- <p class="mb-2 text-center text-base">{{ $t('lagi dipake test dulu component nya nanti di rollback kalo sudah selesai') }}</p>

				<custom-input
					class="mb-3"
					type="text"
					align="left"
					:label="$t('Item Label')"
					v-model="url"
				/> -->
            </template>
			<template slot="footer">
				<div class="w-100 flex-center mt-4">
					<button
						@click="checkLogin"
						type="button"
						class="btn btn-submit btn-primary text-center mr-6"
						:class="{ 'is-loading': isLoggingIn }">
						{{ $t('Ok') }}
					</button>
					<button
						@click="close"
						type="button"
						class="btn btn-submit btn-default text-center">
						{{ $t('Cancel') }}
					</button>
				</div>
			</template>
		</modal>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
// import axios from 'axios';
// import localforage from 'localforage';
import Modal from '@/components/Modal.vue';
// import CustomInput from '@/components/CustomInput.vue';
// import {
// 	getVideoBlob,
// } from '@/lib/helper';

export default {
	name: 'ModalRundownTakeOver',
	components: {
		Modal,
		// CustomInput,
	},
	props: {
		isShowCheckLogin: {
			type: Boolean,
		},
	},
	mounted() {
	},
	data: () => ({
		isLoggingIn: false,
		url: '',
	}),
	methods: {
		close() {
			this.$emit('close');
		},
		checkLogin() {
			this.isLoggingIn = true;
			// @TODO : add take over via socket
			this.$emit('checkLogin');
		},
	},
	beforeDestroy() {
		this.isLoggingIn = false;
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'isLoggedIn',
		}),
	},
};
</script>
